export default __webpack_public_path__ + "src/assets/images/banner_three.jpg?b3ef2f05";